/* eslint-disable @typescript-eslint/consistent-type-assertions */
export * from "./controllers.js";

(function enableScrollPreservation() {
	/* https://github.com/hotwired/turbo/issues/37#issuecomment-1422200868 */
	let scrollTop = 0;

	let shouldPreserveScroll = false;

	document.addEventListener("turbo:click", function (event) {
		if ((event.target as HTMLDivElement).hasAttribute("data-turbo-preserve-scroll")) {
			shouldPreserveScroll = true;
		} else {
			shouldPreserveScroll = false;
		}
	});

	document.addEventListener("turbo:before-visit", function () {
		if (shouldPreserveScroll) {
			scrollTop = document.documentElement.scrollTop;
		}
	});

	addEventListener("turbo:visit", () => {
		/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
		if (shouldPreserveScroll) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
			(window as any).Turbo.navigator.currentVisit.scrolled = true;
			document.documentElement.scrollTop = scrollTop;
		}
		shouldPreserveScroll = false;
	});
})();

/* fix for https://github.com/hotwired/turbo/issues/1255 */
(() => {
	const markHashLinks = (root: ParentNode): void => {
		root.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((link) => {
			link.dataset.turbo = "false";
		});
	};

	markHashLinks(document);

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof Element)) return;

				if (node instanceof HTMLAnchorElement && node.matches('a[href^="#"]')) {
					node.dataset.turbo = "false";
				}

				markHashLinks(node);
			});
		});
	});

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
})();
